import React from "react";
import classes from "./SecondBlock.module.css";
import cn from "clsx";
import Img, { FluidObject } from "gatsby-image";
import { graphql, useStaticQuery } from "gatsby";
import { SecondBlockQuery } from "types/graphql-types";
import Typography from "../ui-kit/Typography";

interface SecondBlockProps {}

const SecondBlock: React.FC<SecondBlockProps> = () => {
  const data: SecondBlockQuery = useStaticQuery(graphql`
    query SecondBlock {
      allFile(
        sort: { order: ASC, fields: relativePath }
        filter: { relativePath: { glob: "SecondBlock/*.png" } }
      ) {
        edges {
          node {
            base
            childImageSharp {
              fluid(maxWidth: 250) {
                ...GatsbyImageSharpFluid_noBase64
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }
  `);
  return (
    <div id="second-block" className={cn(classes.container)}>
      <div className={cn(classes.pets)}>
        {data.allFile.edges.map((n) => (
          <Img
            key={n.node.base}
            fluid={n.node.childImageSharp?.fluid as FluidObject}
          />
        ))}
      </div>
      <div className={cn(classes.textBlock)}>
        <div className={cn(classes.textBlockInner)}>
          <Typography
            color="primary"
            variant="h2"
            className={cn(classes.heading)}
          >
            <b>«Двери не закрываются»</b>
          </Typography>
          <Typography isSemiTransperent color="primary" gutterBottom>
            <b>
              «Двери не закрываются» — еще одна акция благотворительного
              марафона «От всего сердца» в честь дня Московского транспорта. В
              этом году Московский транспорт расскажет: как позаботиться о
              близких, помочь нуждающимся, стать донором или просто подарить
              поездку на метро тем, кому она сейчас так нужна.
            </b>
          </Typography>
          <Typography isSemiTransperent color="primary" gutterBottom>
            <b>
              Символ транспорта — сердце, от которого расходятся дороги-артерии.
              Сердце — это символ жизни, символ доброты и любви.
            </b>
          </Typography>
          <Typography isSemiTransperent color="primary" gutterBottom>
            <b>
              Мы верим, что ваши двери и сердца готовы принять новых
              четвероногих друзей, что «бездомный» — это временный статус
              (просто кот или пес еще не повстречали своего человека). Вместе с
              МаксимаТелеком и компанией Квант, а также с помощью бесплатной
              сети MT_FREE, мы расскажем о животных, которым нужна помощь, а
              самое главное — новый дом и любящие хозяева.
            </b>
          </Typography>
          <Typography isSemiTransperent color="primary" gutterBottom>
            <b>Помогите питомцу приехать домой!</b>
          </Typography>
          <Typography isSemiTransperent color="primary" gutterBottom>
            <b>
              Если вы решите взять одного из животных — участников акции, вам
              предстоит пройти собеседование с его текущим куратором (это могут
              быть сотрудники одного из московских приютов, Adoption-центра или
              просто волонтеры, помогающие животным в поиске дома на
              добровольных началах).
            </b>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default SecondBlock;
